import { GET_DASHBOARD_GRAPH_SUCCESS } from "../constants/dashboardConstants"
import { timeStamp } from "../utils/helpers";



const initialState = {
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    },
    yAxis: {
      type: 'value'
    },
    legend: {},
    series: [
      {
        data: [
          {
            value: 120,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          },
          {
            value: 200,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          },
          {
            value: 150,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          },
          {
            value: 80,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          },
          {
            value: 70,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          },
          {
            value: 110,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          },
          {
            value: 130,
            createdAt: 1679470788,
            itemStyle: {color: '#15A9E1', barBorderRadius: [50, 50]},
          }
        ],
        barWidth: '20%',
        type: 'bar'
      },
      {
        data: [
          {
            value: 100,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          },
          {
            value: 210,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          },
          {
            value: 130,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          },
          {
            value: 100,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          },
          {
            value: 30,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          },
          {
            value: 110,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          },
          {
            value: 130,
            createdAt: 1679470788,
            itemStyle: {color: '#075087', barBorderRadius: [50, 50]},
          }
        ],
        barWidth: '20%',
        type: 'bar'
      }
    ]
}
  
  const dashboardGraph = (state = initialState, { type }) => {
    switch (type) {
      case GET_DASHBOARD_GRAPH_SUCCESS:
        return state
      default:
        return state
    }
  }
  
  export default dashboardGraph